var map = {
	"./ancient.png": 60,
	"./dust2.png": 3687,
	"./inferno.png": 5673,
	"./mirage.png": 6650,
	"./nuke.png": 6780,
	"./overpass.png": 1481,
	"./vertigo.png": 4183
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 3651;